import React, { useState } from 'react'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'

export default ({
  open,
  onOk = () => {},
  onCancel = () => {},
  title = 'Rename',
  message,
  label = 'Name',
  type = 'text',
  placeholder = 'Name',
  defaultName = { placeholder },
  maxLength = 20
}) => {
  const theme = useTheme()

  const [name, setName] = useState(defaultName)

  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'), {
    noSsr: true
  })

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        fullWidth={true}
        open={open}
        onClose={onCancel}
        aria-labelledby='rename-dialog'
      >
        <DialogTitle id='rename-dialog-title'>{title}</DialogTitle>
        <DialogContent>
          {message && <DialogContentText>{message}</DialogContentText>}
          <TextField
            autoFocus
            margin='dense'
            id='name'
            label={label}
            type={type}
            fullWidth
            placeholder={placeholder}
            value={name}
            onChange={e => setName(e.target.value)}
            inputProps={{
              'aria-label': 'attachment-name',
              'data-lpignore': 'true',
              maxLength: { maxLength }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel} color='secondary'>
            Cancel
          </Button>
          <Button
            onClick={() => onOk(name ? name : placeholder)}
            color='primary'
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
